document.addEventListener('variant:changed', (e) => {
  const variant = e.detail.variant;

  if (typeof BOLD !== 'undefined'
    && typeof BOLD.common !== 'undefined'
    && BOLD.common.eventEmitter !== 'undefined') {
    BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: variant });
  }
})